// extracted by mini-css-extract-plugin
module.exports = {"container":"doodad_get_puk_code_container___tJe0"};